import React from 'react'
import e3 from "../../Assets/img/Error/error3.avif";
const ErrorPage = () => {
  return (
    <div className='w-full h-[100vh] 1024px:mt-[80px] 1280px:mt-0'>
      <img src={e3} alt="" className='w-full h-[100vh] object-contain'/>
    </div>
  )
}

export default ErrorPage
